import { render } from "./IngestionPage.vue?vue&type=template&id=4568994a&scoped=true"
import script from "./IngestionPage.vue?vue&type=script&lang=js"
export * from "./IngestionPage.vue?vue&type=script&lang=js"

import "./IngestionPage.vue?vue&type=style&index=0&id=4568994a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4568994a"]])

export default __exports__